import { V2_NOTIFICATION_REDIRECT_CLICK_TYPE } from './constants/v2NotificationRedirect'

export const getV2NotificationRedirectUrl = (
  redirectPath,
  clickType,
  clickContentId
) => {
  if (!redirectPath) {
    return ''
  }

  const encodedRedirectPath = encodeURIComponent(redirectPath)
  let url = `${process.env.WEB_SCHEME}://${process.env.WEB_DOMAIN}/v2/notifications/%serial-nid%/redirect/%nid%?redirectPath=${encodedRedirectPath}`

  if (clickType) {
    url += `&clickType=${clickType}`
  }

  if (clickContentId) {
    url += `&clickedContentId=${clickContentId}`
  }

  return url
}

// These were added in Jun 2025, before that tracked clicks did not match this pattern as they were manually generated for each campaign
export const getClickedContentId = (
  clickType,
  { question, sponsorship } = {}
) => {
  switch (clickType) {
    case V2_NOTIFICATION_REDIRECT_CLICK_TYPE.CAMPAIGN_VIEW_PROGRAM:
    case V2_NOTIFICATION_REDIRECT_CLICK_TYPE.CAMPAIGN_ASK_PROGRAM_QUESTION:
    case V2_NOTIFICATION_REDIRECT_CLICK_TYPE.CAMPAIGN_VIEW_PROGRAM_ABSTRACTS:
    case V2_NOTIFICATION_REDIRECT_CLICK_TYPE.CAMPAIGN_VIEW_PROGRAM_VIDEOS:
    case V2_NOTIFICATION_REDIRECT_CLICK_TYPE.CAMPAIGN_START_CME_PROGRAM:
      return sponsorship?.sponsorshipId
    case V2_NOTIFICATION_REDIRECT_CLICK_TYPE.CAMPAIGN_VIEW_PROGRAM_QUESTION:
      return question?.questionId

    default:
      return undefined
  }
}
